import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Phone, Mail, MessageCircle, CircleCheck } from "lucide-react";
export default function Sidebarhelpcard() {
  const currentStep = 1;
  const totalSteps = 3;
  const progressValue = currentStep / totalSteps * 100;
  const contactInfo = [{
    icon: <Phone className="size-4" />,
    label: "021-1234-5678",
    to: "0823-2121-0234"
  }, {
    icon: <Mail className="size-4" />,
    label: "redaksi@abadi.news",
    to: "mailto:redaksi@abadi.news"
  }, {
    icon: <MessageCircle className="size-4" />,
    label: "WhatsApp Kami",
    to: "https://wa.me/6281234567890"
  }];
  const tips = [{
    id: "tip-1",
    label: "Pastikan foto / video jelas"
  }, {
    id: "tip-2",
    label: "Sertakan lokasi kejadian"
  }, {
    id: "tip-3",
    label: "Wajib Tulis deskripsi singkat 5W+1H"
  }];
  return <section data-section-id="260203" id="sidebarhelpcard" className="bg-background text-foreground py-8">
      <div className="page-container">
        <div className="flex flex-col lg:flex-row lg:justify-end">
          <div className="w-full lg:max-w-[350px] hidden md:block">
            <div className="sticky top-24 rounded-2xl bg-[#4A3728] p-6 shadow-lg text-white">
              <div className="relative z-10 flex flex-col">
                <span className="mb-3 text-[10px] font-bold tracking-[0.2em] text-primary uppercase">
                  Bantuan Redaksi
                </span>
                
                <h2 className="mb-2 font-default text-xl font-bold text-white">
                  Punya Pertanyaan?
                </h2>

                <div className="mb-4">
                  <div className="flex justify-between text-[10px] mb-1 uppercase font-bold tracking-wider opacity-80">
                    <span>Progress Pengiriman</span>
                    <span>Langkah {currentStep}/{totalSteps}</span>
                  </div>
                  <div className="h-1.5 w-full bg-white/20 rounded-lg overflow-hidden">
                    <div className="h-full bg-primary transition-all duration-500 rounded-lg" style={{
                    width: `${progressValue}%`
                  }} />
                  </div>
                  <p className="mt-3 text-xs font-bold text-white">
                    Tahap Sekarang: Detail Informasi
                  </p>
                  <p className="mt-1 text-[11px] text-white/70 italic">
                    Berikutnya: Unggah Media Pendukung
                  </p>
                </div>
                
                <p className="mb-6 text-sm font-sans text-white/80 leading-relaxed">
                  Hubungi tim redaksi kami melalui WhatsApp jika Anda mengalami kendala dalam Kirim Informasi atau laporan.
                </p>

                <div className="mb-8 border-t border-white/10 pt-6">
                  <h3 className="mb-4 text-sm font-bold uppercase tracking-wider text-primary">
                    Tips Citizen Journalism
                  </h3>
                  <div className="flex flex-col gap-3">
                    {tips.map((tip, i) => <div key={tip.id} data-index={i} className="flex items-start gap-3">
                        <div className="mt-0.5 flex size-4 shrink-0 items-center justify-center rounded border border-white/30 bg-white/10">
                          <CircleCheck className="size-3 text-primary" />
                        </div>
                        <span className="text-xs text-white/80">{tip.label}</span>
                      </div>)}
                  </div>
                </div>

                <div className="mb-8 flex flex-col gap-3">
                  {contactInfo.map((item, i) => <Link key={i} data-index={i} to={item.to} className="flex items-center gap-3 text-sm text-white/70 hover:text-primary transition-colors">
                      <span className="text-primary">{item.icon}</span>
                      {item.label}
                    </Link>)}
                </div>
                
                <div className="flex w-full flex-col gap-3">
                  <Button asChild variant="outline" size="lg" className="h-12 w-full rounded-md border-white text-white hover:bg-[#EB7C2D] hover:border-[#EB7C2D] hover:text-white px-8 text-sm font-medium shadow-sm transition-all">
                    <Link to="https://wa.me/6281234567890">Hubungi Redaksi</Link>
                  </Button>
                  
                  <Button asChild variant="outline" size="lg" className="h-12 w-full rounded-md border-white/20 bg-white/10 px-8 text-sm font-medium text-white hover:bg-white/20 hover:text-white">
                    <Link to="#">Kirim Informasi</Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}